import React from 'react'
import { Link } from 'react-router-dom'

const Selector = () => {
    return (
        <div className="row selector-outer-div">
            <div className="col-md-4">
                
            </div>
            <div className="col-md-4 selector-content-div">
                <Link to="/singleminter"> <button className="single-minter-btn"> Single </button> </Link>
                <Link to="/multiminter"> <button className="multi-minter-btn"> Multiple </button> </Link>
            </div>
            <div className="col-md-4">
                
            </div>
        </div>
    )
}

export default Selector
